// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_promise from "../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as React from "@sentry/react";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.mjs";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";

function catchPromiseError(promise, requestUrl) {
  return Js_promise.$$catch((function (error) {
                Logger$Catalyst.error("------promise caught error------");
                Logger$Catalyst.error(error);
                React.captureException(error, {
                      tags: {
                        type: "API_ERROR_CONTRACT"
                      },
                      contexts: {
                        request: {
                          API_URL: requestUrl
                        }
                      }
                    });
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.getDefaultErrorEntity(JSON.stringify(error), undefined, undefined)
                          });
              }), promise);
}

export {
  catchPromiseError ,
}
/* @sentry/react Not a pure module */
